import type { DesktopBgImage } from '@ui/components/DesktopBg';
import type { CoinMode } from '@ui/hooks/useCoinMode';

export const stakeDesktopBg: Record<CoinMode, DesktopBgImage> = {
  cro: 'PATTERN_3',
  atom: 'PATTERN_3_ATOM',
  eth: 'STAKE_ETH_BG_DESKTOP',
  tia: 'STAKE_TIA_BG_DESKTOP',
};
